import { useEffect, useState, useCallback } from "react";
import i18next from "i18next";
import { ensureI18nInitialized, changeLanguage as changeLanguageCore, getCurrentLanguage, } from "../core/i18n";
export function useTranslation(namespace) {
    const [language, setLanguage] = useState(() => getCurrentLanguage());
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        let isMounted = true;
        const initializeI18n = async () => {
            try {
                await ensureI18nInitialized();
                if (isMounted) {
                    setIsInitialized(true);
                    setLanguage(getCurrentLanguage());
                }
            }
            catch (error) {
                console.error("Failed to initialize i18n:", error);
                if (isMounted) {
                    setIsInitialized(true);
                }
            }
        };
        initializeI18n();
        return () => {
            isMounted = false;
        };
    }, []);
    useEffect(() => {
        if (!isInitialized) {
            return;
        }
        const handleLanguageChanged = (lng) => {
            setLanguage(lng);
        };
        i18next.on("languageChanged", handleLanguageChanged);
        return () => {
            i18next.off("languageChanged", handleLanguageChanged);
        };
    }, [isInitialized]);
    const t = useCallback((key, defaultValue, options) => {
        if (!isInitialized) {
            return defaultValue || key;
        }
        const result = i18next.t(key, {
            defaultValue,
            ns: namespace,
            ...options,
        });
        return typeof result === "string" ? result : String(result);
    }, [isInitialized, namespace]);
    const changeLanguage = useCallback(async (lng) => {
        await changeLanguageCore(lng);
        setLanguage(getCurrentLanguage());
    }, []);
    return {
        t,
        language,
        changeLanguage,
        i18n: i18next,
    };
}
